import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { ColorModel } from '~/core/models';

export interface ColorVizContentProps {
  showColorVisualizer: boolean;
  selectedColor?: ColorModel;
  setShowColorVisualizer: (showColorVisualizer: boolean) => void;
  setColorVizImage: (colorVizImage: string) => void;
  colorVizName: string;
  setColorVizName: (colorVizName: string) => void;
  showColorModal: () => void;
}

const ColorVizContent = ({
  showColorVisualizer,
  selectedColor,
  setShowColorVisualizer,
  setColorVizImage,
  colorVizName,
  setColorVizName,
  showColorModal,
}: ColorVizContentProps): JSX.Element | null => {
  const { t } = useTranslation();

  const closeColorVisualizer = () => {
    // add code here to grab and use visualizer data
    const visualizerFrame = document?.querySelector(
      '#visualizer-iframe'
    ) as HTMLIFrameElement;

    if (visualizerFrame.contentWindow) {
      visualizerFrame.contentWindow.postMessage(
        {
          // This tells visualizer to create a screenshot and return it with the information about applied materials
          action: 'getScreenshot',
        },
        'https://slabcloud.com'
      );

      window.onmessage = function (e) {
        //received data from the visualizer e.data
        const applied = e.data.appliedMaterials;

        if (
          !e.data.screenshotImg ||
          Object.keys(applied).length === 0 ||
          !selectedColor
        ) {
          return undefined;
        }

        let ii = 0;
        let countertopColorName;

        for (const property in applied) {
          const item = applied[property];

          if (ii === 2) {
            countertopColorName = item.materialName;
          }
          ii += 1;
        }

        if (countertopColorName !== selectedColor.name) {
          // check to see which visualizer selected color the user wants to switch to in the estimator tool
          setColorVizImage(e.data.screenshotImg);
          setColorVizName(countertopColorName ?? colorVizName);
          showColorModal();
        }

        return undefined;
      };

      setShowColorVisualizer(false);
    }
  };

  if (!showColorVisualizer) {
    return null;
  }

  return (
    <Modal
      className="visualizer-modal"
      open={showColorVisualizer}
      onCancel={closeColorVisualizer}
      width="auto"
      centered
      footer={null}
      title={t('SCROLLABLE_AREA.COLOR.VISUALIZE')}
      closable
    >
      <div className="modal-content">
        <div id="visualizer-container">
          {selectedColor ? (
            <iframe
              title="roomvo-visualizer"
              allowFullScreen
              width="1200"
              height="800"
              src={
                'https://slabcloud.com/visualizer3d/?company=inscyth&stone_name=' +
                selectedColor.name
              }
              id="visualizer-iframe"
            />
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default ColorVizContent;
